<template>
  <div class="my_select_index">
    <p :class="type == 'one_level' ? 'set_one_level': 'set_two_level'">
      <span v-text="title" class="title" :style="{
      width: !Number.isNaN(Number(titleWidth)) ? titleWidth + 'px' : titleWidth
     }"></span>
      <el-select
        ref="selector"
        :style="{ width: width + 'px' }"
        class="module"
        v-model="Result"
        :placeholder="placeholder"
        :disabled="disabled"
        size="small"
        @change="change"
        @visible-change="visible_change"
      >
      <slot name="history"></slot>
        <template v-if="isGroup">
          <el-option-group
            v-for="group in options"
            :key="group.label"
            :label="$t(group.label)">
            <el-option
              v-for="item in group.options"
              :key="item.value"
              :label="$t(item.label)"
              :value="item.value">
              <svg v-if="$store.state.options.fontFamilySystem[item.value]" class="font_svg"><use :xlink:href="$store.state.options.fontFamilySystem[item.value]"></use></svg>
              <span v-else :class="item.label" v-text="$t(item.label)"></span>
            </el-option>
          </el-option-group>
        </template>
        <template v-else>
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="$t(item.label)"
            :value="item.value"
          >
          <svg v-if="$store.state.options.fontFamilySystem[item.value]" class="font_svg"><use :xlink:href="$store.state.options.fontFamilySystem[item.value]"></use></svg>
          <span v-else :class="item.label" v-text="$t(item.label)"></span>
          </el-option>
        </template>
      </el-select>
    </p>
  </div>
</template>

<script>
export default {
  name: 'my_select_index',
  props: {
    title: { // 组件的标题
      type: String,
      default: ''
    },
    type: { // 组件的类型  one_level 一级组件 two_level 二级组件
      type: String,
      default: 'two_level'
    },
    value: { // 输入框的值
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isGroup: {
      type: Boolean,
      default: false
    },
    options: { // 数组
      type: Array,
      default: function () {
        return []
      }
    },
    width: {
      type: String,
      default: '118'
    },
    titleWidth: {
      type: String,
      default: '40'
    }
  },
  data() {
    return {
      Result: this.value
    }
  },
  watch: {
    Result(val) {
      this.$emit('update:value', val);//双向数据绑定
    },
    value(val) {
      this.Result = this.value
    }
  },
  computed: {},
  methods: {
    change() {
      this.$emit('change', this.Result);
    },
    visible_change(val) {
      if (val) {
        $(".main_dialog").draggable('disable')
      } else {
        $(".main_dialog").draggable('enable')
      }
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
@import "src/css/components/special_fonts";
</style>



// WEBPACK FOOTER //
// src/components/my_select/index.vue